import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycAnOverviewOfElderLawPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-an-overview-of-elder-law/']} />;
}
